export default "__VITE_ASSET__BA_O13Cl__"